import React from 'react';
import classNames from 'classnames';
import {Switch as TWSwitch} from '@headlessui/react';

interface Props {
    checked: boolean;
    onChange: (checked: boolean) => void;
    size?: 'xs' | 'base';
    description?: string;
    disabled?: boolean;
}

export const Switch = ({checked, onChange, size = 'base', description, disabled}: Props) => {
    return (
        <TWSwitch
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            className={classNames(
                checked && 'bg-blue-500',
                !checked && 'bg-slate-500',
                disabled && 'opacity-30',
                'relative inline-flex  shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75',
                size === 'base' && 'h-[38px] w-[74px]',
                size === 'xs' && 'h-[18px] w-[36px]'
            )}
        >
            {description && <span className="sr-only">{description}</span>}
            <span
                aria-hidden="true"
                className={classNames(
                    'pointer-events-none inline-block transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out',
                    checked && 'translate-x-9',
                    !checked && 'translate-x-0',
                    size === 'base' && 'h-[34px] w-[34px]',
                    size === 'xs' && 'h-[14px] w-[14px]',
                    size === 'xs' && checked && 'translate-x-[18px]'
                )}
            />
        </TWSwitch>
    );
};
